import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NewIndexComponent } from './new-index-home/new-index-home.component';
import { NewIndexRoutingModule } from './new-index-routing.module';
import { NewService } from '../news/new.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NewIndexRoutingModule,
  ],
  declarations: [
    NewIndexComponent
  ],
  providers: [
    NewService
  ]
})
export class NewIndexModule { }
